import * as size from './size.js'
import * as preload from './preload.js'
import * as proc from './proc.js'

const main = async function() {
    // Select element and init size
    const element = document.querySelector('#app');
    size.init(element, 800, 800);

    // Initialize
    const app = new PIXI.Application();
    await app.init({ background: '#419739', width: size.rw, height: size.rh });
                    // resizeTo: element
    element.append(app.canvas);
    app.view.style.touchAction = 'auto';    // Can scroll

    // Preload images, fonts
    const { cards } = await preload.load();

    // Process
    // app.renderer.width  === size.rw
    // app.renderer.height === size.rh
    const params = { app, w: app.renderer.width, h: app.renderer.height, cards };
    proc.start(params);
};
main();

